import { SocialLink } from '../types';

export const socialLinks: SocialLink[] = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/robots.jpg/",
    icon: "instagram"
  },
  {
    name: "YouTube",
    url: "https://youtube.com/@JeremyGermita",
    icon: "youtube"
  }
]; 